import { fabric } from 'fabric';
import { getState, modifyState } from '~src/state';

export const updateCloneStampBrush = () => {
  const brushRadius = parseFloat(getState('cloneStampBrushRadius'));
  const brushAlpha = parseFloat(getState('cloneStampBrushAlpha'));
  const brushHardness = parseFloat(getState('cloneStampBrushHardness'));

  window.CloneStamp.updateBrushSettings(brushRadius, brushHardness, brushAlpha);

  if (window.CloneStamp.mode !== window.CloneStamp.MODE_SMUDGE) {
    const cursorCanvas = getState('cursorCanvas');
    new fabric.Image.fromURL(
      window.brushCanvas.toDataURL('image/png'),
      (img) => {
        cursorCanvas.clear();
        img.set({ visible: true });
        cursorCanvas.add(img);
        cursorCanvas.requestRenderAll();
        const mouseCursor = cursorCanvas.getObjects()[0];
        modifyState('mouseCursorStampClone', mouseCursor);
      }
    );
  }
};
